(function () {
  'use strict';

  var STICKY_SELECTOR = '[data-mnj-promo-sticky]';
  var MOBILE_MQ = window.matchMedia('(max-width: 749px)');

  function initSticky() {
    var sticky = document.querySelector(STICKY_SELECTOR);
    if (!sticky) return;

    var heroSelector = sticky.getAttribute('data-mnj-promo-sticky-hero');
    var hero = heroSelector ? document.querySelector(heroSelector) : null;
    var onHome = document.body.classList.contains('mnj-index-home');

    function setVisible(show) {
      if (show) {
        sticky.hidden = false;
        sticky.setAttribute('data-mnj-promo-sticky-visible', '');
        document.body.classList.add('mnj-promo-sticky-active');
      } else {
        sticky.removeAttribute('data-mnj-promo-sticky-visible');
        document.body.classList.remove('mnj-promo-sticky-active');
        if (!MOBILE_MQ.matches) {
          sticky.hidden = true;
        }
      }
    }

    function update() {
      if (!MOBILE_MQ.matches) {
        setVisible(false);
        sticky.hidden = true;
        return;
      }

      sticky.hidden = false;

      if (onHome && hero) {
        var rect = hero.getBoundingClientRect();
        var heroVisible = rect.bottom > 80;
        setVisible(!heroVisible);
        return;
      }

      setVisible(true);
    }

    if (onHome && hero && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          if (!MOBILE_MQ.matches) return;
          var entry = entries[0];
          setVisible(!entry.isIntersecting);
        },
        { root: null, rootMargin: '-60px 0px 0px 0px', threshold: 0 }
      );
      observer.observe(hero);
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (MOBILE_MQ.addEventListener) {
      MOBILE_MQ.addEventListener('change', update);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSticky);
  } else {
    initSticky();
  }
})();
